import '../../assets/index56.css';var _e = Object.defineProperty, ye = Object.defineProperties;
var Me = Object.getOwnPropertyDescriptors;
var R = Object.getOwnPropertySymbols;
var ne = Object.prototype.hasOwnProperty, re = Object.prototype.propertyIsEnumerable;
var te = (e, o, t) => o in e ? _e(e, o, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[o] = t, u = (e, o) => {
  for (var t in o || (o = {}))
    ne.call(o, t) && te(e, t, o[t]);
  if (R)
    for (var t of R(o))
      re.call(o, t) && te(e, t, o[t]);
  return e;
}, w = (e, o) => ye(e, Me(o));
var C = (e, o) => {
  var t = {};
  for (var r in e)
    ne.call(e, r) && o.indexOf(r) < 0 && (t[r] = e[r]);
  if (e != null && R)
    for (var r of R(e))
      o.indexOf(r) < 0 && re.call(e, r) && (t[r] = e[r]);
  return t;
};
import { jsx as a, jsxs as P, Fragment as Ie } from "react/jsx-runtime";
import k, { useState as ie, useRef as W, useEffect as De, forwardRef as Ce, cloneElement as ae, createContext as xe, useContext as Se, isValidElement as ke } from "react";
import { Button as be } from "../Button/index.js";
import { TextField as Te } from "../TextField/index.js";
import { Text as se } from "../Text/index.js";
import { MagnifyingGlassFarFAIcon as Ne, CheckFarFAIcon as Pe } from "../Icons/index.js";
import { f as Ee, c as Le } from "../../create-scoped-keydown-handler-7Vh4D_UG.js";
import { u as Fe } from "../../use-resolved-styles-api-D-aL_8KF.js";
import { u as Ae } from "../../use-styles-DToiHEa6.js";
import { f as j, u as E, B as ce, b as Ve, p as $e, q as Oe } from "../../factory-ueRxoNOV.js";
import { P as q } from "../../Popover-CchFr99F.js";
import { c as Re } from "../../create-safe-context-DqDyoPVE.js";
import { u as le } from "../../use-merged-ref-n551Tfbr.js";
import { p as We } from "../../polymorphic-factory-DufevJAl.js";
import { u as ze } from "../../DirectionProvider-CT8S13Cp.js";
import { U as Ke } from "../../UnstyledButton-D9OCzDhz.js";
import { i as Ue } from "../../is-element-C00Aie10.js";
import { u as Be } from "../../use-uncontrolled-BT_j5D2R.js";
import { u as He } from "../../use-reduced-motion-C9DbPZfj.js";
function x(e, o) {
  return (t) => {
    e == null || e(t), o == null || o(t);
  };
}
function je(e, o, t) {
  var r;
  return t ? Array.from(
    ((r = Ee(t, o)) == null ? void 0 : r.querySelectorAll(e)) || []
  ).findIndex((s) => s === t) : null;
}
function qe() {
  const [e, o] = ie(-1);
  return [e, { setHovered: o, resetHovered: () => o(-1) }];
}
function Ye({ open: e, close: o, openDelay: t, closeDelay: r }) {
  const s = W(-1), n = W(-1), m = () => {
    window.clearTimeout(s.current), window.clearTimeout(n.current);
  }, c = () => {
    m(), t === 0 || t === void 0 ? e() : s.current = window.setTimeout(e, t);
  }, p = () => {
    m(), r === 0 || r === void 0 ? o() : n.current = window.setTimeout(o, r);
  };
  return De(() => m, []), { openDropdown: c, closeDropdown: p };
}
const [Ge, A] = Re(
  "Menu component was not found in the tree"
);
var L = { dropdown: "m_dc9b7c9f", label: "m_9bfac126", divider: "m_efdf90cb", item: "m_99ac2aa1", itemLabel: "m_5476e0d3", itemSection: "m_8b75e504" };
const Ze = {}, Y = j((e, o) => {
  const d = E(
    "MenuDivider",
    Ze,
    e
  ), { classNames: t, className: r, style: s, styles: n, vars: m } = d, c = C(d, ["classNames", "className", "style", "styles", "vars"]), p = A();
  return /* @__PURE__ */ a(
    ce,
    u(u({
      ref: o
    }, p.getStyles("divider", { className: r, style: s, styles: n, classNames: t })), c)
  );
});
Y.classes = L;
Y.displayName = "@mantine/core/MenuDivider";
const Je = {}, G = j((e, o) => {
  const M = E("MenuDropdown", Je, e), {
    classNames: t,
    className: r,
    style: s,
    styles: n,
    vars: m,
    onMouseEnter: c,
    onMouseLeave: p,
    onKeyDown: d,
    children: _
  } = M, b = C(M, [
    "classNames",
    "className",
    "style",
    "styles",
    "vars",
    "onMouseEnter",
    "onMouseLeave",
    "onKeyDown",
    "children"
  ]), f = W(null), h = A(), v = x(d, (I) => {
    var F, D;
    (I.key === "ArrowUp" || I.key === "ArrowDown") && (I.preventDefault(), (D = (F = f.current) == null ? void 0 : F.querySelectorAll("[data-menu-item]:not(:disabled)")[0]) == null || D.focus());
  }), i = x(
    c,
    () => (h.trigger === "hover" || h.trigger === "click-hover") && h.openDropdown()
  ), g = x(
    p,
    () => (h.trigger === "hover" || h.trigger === "click-hover") && h.closeDropdown()
  );
  return /* @__PURE__ */ P(
    q.Dropdown,
    w(u(w(u({}, b), {
      onMouseEnter: i,
      onMouseLeave: g,
      role: "menu",
      "aria-orientation": "vertical",
      ref: le(o, f)
    }), h.getStyles("dropdown", {
      className: r,
      style: s,
      styles: n,
      classNames: t,
      withStaticClass: !1
    })), {
      tabIndex: -1,
      "data-menu-dropdown": !0,
      onKeyDown: v,
      children: [
        h.withInitialFocusPlaceholder && /* @__PURE__ */ a("div", { tabIndex: -1, "data-autofocus": !0, "data-mantine-stop-propagation": !0, style: { outline: 0 } }),
        _
      ]
    })
  );
});
G.classes = L;
G.displayName = "@mantine/core/MenuDropdown";
const Qe = {}, Z = We((e, o) => {
  const $ = E("MenuItem", Qe, e), {
    classNames: t,
    className: r,
    style: s,
    styles: n,
    vars: m,
    color: c,
    closeMenuOnClick: p,
    leftSection: d,
    rightSection: _,
    children: b,
    disabled: f,
    "data-disabled": h
  } = $, v = C($, [
    "classNames",
    "className",
    "style",
    "styles",
    "vars",
    "color",
    "closeMenuOnClick",
    "leftSection",
    "rightSection",
    "children",
    "disabled",
    "data-disabled"
  ]), i = A(), g = Ve(), { dir: M } = ze(), I = W(null), F = i.getItemIndex(I.current), D = v, V = x(D.onMouseLeave, () => i.setHovered(-1)), K = x(
    D.onMouseEnter,
    () => i.setHovered(i.getItemIndex(I.current))
  ), U = x(D.onClick, () => {
    h || (typeof p == "boolean" ? p && i.closeDropdownImmediately() : i.closeOnItemClick && i.closeDropdownImmediately());
  }), B = x(
    D.onFocus,
    () => i.setHovered(i.getItemIndex(I.current))
  ), T = c ? g.variantColorResolver({ color: c, theme: g, variant: "light" }) : void 0, S = c ? $e({ color: c, theme: g }) : null;
  return /* @__PURE__ */ P(
    Ke,
    w(u(w(u({}, v), {
      unstyled: i.unstyled,
      tabIndex: i.menuItemTabIndex,
      onFocus: B
    }), i.getStyles("item", { className: r, style: s, styles: n, classNames: t })), {
      ref: le(I, o),
      role: "menuitem",
      disabled: f,
      "data-menu-item": !0,
      "data-disabled": f || h || void 0,
      "data-hovered": i.hovered === F ? !0 : void 0,
      "data-mantine-stop-propagation": !0,
      onMouseEnter: K,
      onMouseLeave: V,
      onClick: U,
      onKeyDown: Le({
        siblingSelector: "[data-menu-item]:not([data-disabled])",
        parentSelector: "[data-menu-dropdown]",
        activateOnFocus: !1,
        loop: i.loop,
        dir: M,
        orientation: "vertical",
        onKeyDown: D.onKeyDown
      }),
      __vars: {
        "--menu-item-color": S != null && S.isThemeColor && (S == null ? void 0 : S.shade) === void 0 ? `var(--mantine-color-${S.color}-6)` : T == null ? void 0 : T.color,
        "--menu-item-hover": T == null ? void 0 : T.hover
      },
      children: [
        d && /* @__PURE__ */ a("div", w(u({}, i.getStyles("itemSection", { styles: n, classNames: t })), { "data-position": "left", children: d })),
        b && /* @__PURE__ */ a("div", w(u({}, i.getStyles("itemLabel", { styles: n, classNames: t })), { children: b })),
        _ && /* @__PURE__ */ a("div", w(u({}, i.getStyles("itemSection", { styles: n, classNames: t })), { "data-position": "right", children: _ }))
      ]
    })
  );
});
Z.classes = L;
Z.displayName = "@mantine/core/MenuItem";
const Xe = {}, J = j((e, o) => {
  const d = E(
    "MenuLabel",
    Xe,
    e
  ), { classNames: t, className: r, style: s, styles: n, vars: m } = d, c = C(d, ["classNames", "className", "style", "styles", "vars"]), p = A();
  return /* @__PURE__ */ a(
    ce,
    u(u({
      ref: o
    }, p.getStyles("label", { className: r, style: s, styles: n, classNames: t })), c)
  );
});
J.classes = L;
J.displayName = "@mantine/core/MenuLabel";
const eo = {
  refProp: "ref"
}, de = Ce((e, o) => {
  const _ = E("MenuTarget", eo, e), { children: t, refProp: r } = _, s = C(_, ["children", "refProp"]);
  if (!Ue(t))
    throw new Error(
      "Menu.Target component children should be an element or a component that accepts ref. Fragments, strings, numbers and other primitive values are not supported"
    );
  const n = A(), m = t.props, c = x(m.onClick, () => {
    n.trigger === "click" ? n.toggleDropdown() : n.trigger === "click-hover" && (n.setOpenedViaClick(!0), n.opened || n.openDropdown());
  }), p = x(
    m.onMouseEnter,
    () => (n.trigger === "hover" || n.trigger === "click-hover") && n.openDropdown()
  ), d = x(m.onMouseLeave, () => {
    (n.trigger === "hover" || n.trigger === "click-hover" && !n.openedViaClick) && n.closeDropdown();
  });
  return /* @__PURE__ */ a(q.Target, w(u({ refProp: r, popupType: "menu", ref: o }, s), { children: ae(t, {
    onClick: c,
    onMouseEnter: p,
    onMouseLeave: d,
    "data-expanded": n.opened ? !0 : void 0
  }) }));
});
de.displayName = "@mantine/core/MenuTarget";
const oo = {
  trapFocus: !0,
  closeOnItemClick: !0,
  withInitialFocusPlaceholder: !0,
  clickOutsideEvents: ["mousedown", "touchstart", "keydown"],
  loop: !0,
  trigger: "click",
  openDelay: 0,
  closeDelay: 100,
  menuItemTabIndex: -1
};
function l(e) {
  const o = E("Menu", oo, e), oe = o, {
    children: t,
    onOpen: r,
    onClose: s,
    opened: n,
    defaultOpened: m,
    trapFocus: c,
    onChange: p,
    closeOnItemClick: d,
    loop: _,
    closeOnEscape: b,
    trigger: f,
    openDelay: h,
    closeDelay: v,
    classNames: i,
    styles: g,
    unstyled: M,
    variant: I,
    vars: F,
    menuItemTabIndex: D,
    keepMounted: V,
    withInitialFocusPlaceholder: K
  } = oe, U = C(oe, [
    "children",
    "onOpen",
    "onClose",
    "opened",
    "defaultOpened",
    "trapFocus",
    "onChange",
    "closeOnItemClick",
    "loop",
    "closeOnEscape",
    "trigger",
    "openDelay",
    "closeDelay",
    "classNames",
    "styles",
    "unstyled",
    "variant",
    "vars",
    "menuItemTabIndex",
    "keepMounted",
    "withInitialFocusPlaceholder"
  ]), B = Ae({
    name: "Menu",
    classes: L,
    props: o,
    classNames: i,
    styles: g,
    unstyled: M
  }), [T, { setHovered: S, resetHovered: $ }] = qe(), [N, Q] = Be({
    value: n,
    defaultValue: m,
    finalValue: !1,
    onChange: p
  }), [me, X] = ie(!1), O = () => {
    Q(!1), X(!1), N && (s == null || s());
  }, H = () => {
    Q(!0), !N && (r == null || r());
  }, ee = () => {
    N ? O() : H();
  }, { openDropdown: pe, closeDropdown: fe } = Ye({ open: H, close: O, closeDelay: v, openDelay: h }), he = (ge) => je("[data-menu-item]", "[data-menu-dropdown]", ge), { resolvedClassNames: ve, resolvedStyles: we } = Fe({
    classNames: i,
    styles: g,
    props: o
  });
  return He(() => {
    $();
  }, [N]), /* @__PURE__ */ a(
    Ge,
    {
      value: {
        getStyles: B,
        opened: N,
        toggleDropdown: ee,
        getItemIndex: he,
        hovered: T,
        setHovered: S,
        openedViaClick: me,
        setOpenedViaClick: X,
        closeOnItemClick: d,
        closeDropdown: f === "click" ? O : fe,
        openDropdown: f === "click" ? H : pe,
        closeDropdownImmediately: O,
        loop: _,
        trigger: f,
        unstyled: M,
        menuItemTabIndex: D,
        withInitialFocusPlaceholder: K
      },
      children: /* @__PURE__ */ a(
        q,
        w(u({}, U), {
          opened: N,
          onChange: ee,
          defaultOpened: m,
          trapFocus: V ? !1 : c,
          closeOnEscape: b,
          __staticSelector: "Menu",
          classNames: ve,
          styles: we,
          unstyled: M,
          variant: I,
          keepMounted: V,
          children: t
        })
      )
    }
  );
}
l.extend = (e) => e;
l.withProps = Oe(l);
l.classes = L;
l.displayName = "@mantine/core/Menu";
l.Item = Z;
l.Label = J;
l.Dropdown = G;
l.Target = de;
l.Divider = Y;
const to = "Menu-module__dropdown___53Bzz", no = "Menu-module__dropdownWithSearch___xn2Tu", ro = "Menu-module__divider___9pM-e", so = "Menu-module__itemWrapper___rfaY6", io = "Menu-module__itemLabel___PVs5w", ao = "Menu-module__item___kSEEH", co = "Menu-module__checkIcon___UZM1z", lo = "Menu-module__searchContainer___-pUR4", uo = "Menu-module__searchInput___6C8zC", mo = "Menu-module__emptyState___-v1cN", po = "Menu-module__emptyStateIcon___w2dAw", fo = "Menu-module__emptyStateTitle___40irE", ho = "Menu-module__emptyStateDescription___Cw6Y2", y = {
  dropdown: to,
  dropdownWithSearch: no,
  divider: ro,
  itemWrapper: so,
  itemLabel: io,
  item: ao,
  checkIcon: co,
  searchContainer: lo,
  searchInput: uo,
  emptyState: mo,
  emptyStateIcon: po,
  emptyStateTitle: fo,
  emptyStateDescription: ho
}, ue = xe({ disabled: !1 }), z = (c) => {
  var p = c, {
    disabled: e,
    closeOnItemClick: o = !0,
    withSearch: t,
    searchPlaceholder: r = "Search",
    emptyState: s,
    children: n
  } = p, m = C(p, [
    "disabled",
    "closeOnItemClick",
    "withSearch",
    "searchPlaceholder",
    "emptyState",
    "children"
  ]);
  const [d, _] = k.useState(""), b = t ? `${y.dropdown} ${y.dropdownWithSearch}` : y.dropdown;
  return /* @__PURE__ */ a(ue.Provider, { value: { disabled: e != null ? e : !1 }, children: /* @__PURE__ */ a(
    l,
    w(u({
      position: "bottom-start",
      offset: 2,
      classNames: w(u({}, y), { dropdown: b }),
      trigger: "click",
      closeOnItemClick: o
    }, m), {
      children: t ? /* @__PURE__ */ P(Ie, { children: [
        k.Children.map(
          k.Children.toArray(n).filter(
            (f) => !k.isValidElement(f) || f.type !== l.Dropdown
          ),
          (f) => f
        ),
        /* @__PURE__ */ P(l.Dropdown, { children: [
          /* @__PURE__ */ a("div", { className: y.searchContainer, children: /* @__PURE__ */ a("div", { className: y.searchInput, children: /* @__PURE__ */ a(
            Te,
            {
              placeholder: r,
              value: d,
              onChange: (f) => _(f.currentTarget.value),
              label: void 0,
              leftSection: /* @__PURE__ */ a(Ne, {})
            }
          ) }) }),
          (() => {
            const h = k.Children.toArray(n).filter((v) => k.isValidElement(v) && v.type === l.Dropdown).flatMap((v) => k.isValidElement(v) ? k.Children.toArray(v.props.children) : []).filter((v) => {
              if (!k.isValidElement(v)) return !1;
              if (v.type === l.Divider) return d === "";
              let i = "";
              const g = v.props;
              return typeof g.children == "string" ? i = g.children : Array.isArray(g.children) && (i = g.children.filter((M) => typeof M == "string").join(" ")), i.toLowerCase().includes(d.toLowerCase());
            });
            return h.length === 0 && d !== "" ? (console.log("Showing empty state"), /* @__PURE__ */ P("div", { className: y.emptyState, style: { padding: "16px", textAlign: "center" }, children: [
              (s == null ? void 0 : s.icon) && /* @__PURE__ */ a("div", { className: y.emptyStateIcon, style: { marginBottom: "8px" }, children: s.icon }),
              /* @__PURE__ */ a("div", { className: y.emptyStateTitle, children: /* @__PURE__ */ a(se, { prominent: !0, size: "md", children: (s == null ? void 0 : s.title) || "Nothing found" }) }),
              (s == null ? void 0 : s.description) && /* @__PURE__ */ a("div", { className: y.emptyStateDescription, style: { fontSize: "0.875rem" }, children: /* @__PURE__ */ a(se, { size: "sm", children: s.description }) })
            ] })) : h;
          })()
        ] })
      ] }) : n
    })
  ) });
}, vo = (t) => {
  var r = t, { children: e } = r, o = C(r, ["children"]);
  const { disabled: s } = Se(ue), n = w(u({}, o), { disabled: s });
  if (typeof e == "string")
    return /* @__PURE__ */ a(l.Target, { children: /* @__PURE__ */ a(be, w(u({}, n), { children: e })) });
  if (ke(e)) return /* @__PURE__ */ a(l.Target, { children: ae(e, n) });
}, wo = (e) => {
  const c = e, { "data-selected": o, children: t, leftSection: r, onClick: s } = c, n = C(c, ["data-selected", "children", "leftSection", "onClick"]), m = o === !0 || o === "true";
  return /* @__PURE__ */ P(
    l.Item,
    w(u({}, n), {
      "data-selected": o,
      leftSection: r,
      onClick: s,
      children: [
        t,
        m && /* @__PURE__ */ a(Pe, { className: y.checkIcon })
      ]
    })
  );
};
z.Item = wo;
z.Target = vo;
z.Dropdown = l.Dropdown;
z.Divider = l.Divider;
export {
  z as Menu
};
